<stx-page-with-sidebar>
  <ng-container slot="body">
    <stx-treatment-center-details [treatmentCenterId]="treatmentCenterId"></stx-treatment-center-details>
  </ng-container>
  @if (statisticsTable) {
  <ng-container slot="sidebar">
    <div class="flex-fill">
      <stx-statistics [statisticsTable]="statisticsTable" [statisticsPlots]="statisticsPlots"></stx-statistics>
    </div>
  </ng-container>
  }
</stx-page-with-sidebar>
